import axios from 'http.service';
import appendToSearchParams from 'Common/Utils/appendToSearchParams';
import apiErrorMsg from 'Common/Utils/apiErrorMsg';

const baseUrl = '/api/v2/appointments';

const getTypes = async (year, grouping, teams, errorCb) => {
	const groupingEncoded = encodeURIComponent(grouping);
	const query = new URLSearchParams();
	appendToSearchParams(query, 'teams', teams);
	const teamsQuery = query.toString();
	const url = `${baseUrl}/types/${year}/${groupingEncoded}${teamsQuery ? `?${teamsQuery}` : ''}`;
	const {
		status,
		data: {	data, errors }
	} = await axios.get(url);
	if (status === 200) {
		return data;
	}
	const errorMessage = apiErrorMsg(status, errors);
	return errorCb(errorMessage);
};

const getTeams = async (year, grouping, types, includeId, errorCb) => {
	const groupingEncoded = encodeURIComponent(grouping);
	const query = new URLSearchParams();
	appendToSearchParams(query, 'types', types);
	query.append('includeId', includeId);
	const url = `${baseUrl}/teams/${year}/${groupingEncoded}?${query.toString()}`;
	const {
		status,
		data: {	data, errors }
	} = await axios.get(url);
	if (status === 200) {
		return data;
	}
	const errorMessage = apiErrorMsg(status, errors);
	return errorCb(errorMessage);
};


export { getTypes, getTeams };
